import { JSONContent } from '@tiptap/core';

import { getExtensions } from 'approot/shared/richtext/richtext.utils';

export const MARKING_GUIDE_SETTINGS = {
  placeholder: '',
  canBold: true,
  canItalic: true,
  canUnderline: true,
  canAddLists: false,
  canChangeHistory: false,
};

export const MARKING_GUIDE_RICHTEXT = getExtensions({
  placeholder: '',
  canBold: true,
  canItalic: true,
  canUnderline: true,
  canAddLists: true,
  canChangeHistory: true,
});

export type MarkingGuide = {
  id: string;
  mark: number | null;
  description: JSONContent | null;
};
